import { IconLayerGray, IconLayers, IconPcLine, IconSecurity } from '@assets/images/icon';
import { IconComputer, IconGuarantee } from '@assets/images/main';
import { IconOsEdgeOff, IconOsEdgeOn, IconOsServerOff, IconOsServerOn, IconOsSwitchOff, IconOsSwitchOn } from '@assets/images/main/icon';
import {
  IconBlueCircle,
  IconBlueCycle,
  IconBlueDevelop,
  IconBlueFigure,
  IconBluePlus,
  IconBluePower,
  IconBlueScan,
  IconBlueShield,
} from '@assets/images/main/icon/blue';
import { osBanner, osDownloadD, osDownloadM, osDownloadT, osLogoDesktop, osLogoMobile, osLogoTablet } from '@assets/images/main/os/bannerImg';
import {
  OsSectionDesktop1,
  OsSectionTablet1,
  OsSectionMobile1,
  OsSectionDesktop2,
  OsSectionTablet2,
  OsSectionMobile2,
  OsSectionDesktop3,
  OsSectionTablet3,
  OsSectionMobile3,
  OsSectionDesktop4,
  OsSectionTablet4,
  OsSectionMobile4,
  OsSectionDesktop5,
  OsSectionTablet5,
  OsSectionMobile5,
  OsSectionDesktop6,
  OsSectionTablet6,
  OsSectionMobile6,
  OsSectionDesktop7,
  OsSectionTablet7,
  OsSectionMobile7,
  OsSectionDesktop8,
  OsSectionTablet8,
  OsSectionMobile8,
  OsSectionDesktop9,
  OsSectionTablet9,
  OsSectionMobile9,
  OsSectionDesktop10,
  OsSectionTablet10,
  OsSectionMobile10,
  OsSectionDesktop11,
  OsSectionTablet11,
  OsSectionMobile11,
  OsSectionDesktop12,
  OsSectionTablet12,
  OsSectionMobile12,
  OsSectionDesktop13,
  OsSectionTablet13,
  OsSectionMobile13,
  OsSectionDesktop14,
  OsSectionTablet14,
  OsSectionMobile14,
  OsSectionDesktop15,
  OsSectionTablet15,
  OsSectionMobile15,
  OsTextImg1,
  OsTextImg2,
  OsTextImg3,
  OsTextImg4,
  OsSectionDesktop16,
  OsSectionTablet16,
  OsSectionMobile16,
  OsSectionDesktop17,
  OsSectionTablet17,
  OsSectionMobile17,
  OsSectionDesktop18,
  OsSectionTablet18,
  OsSectionMobile18,
  OsSectionDesktop19,
  OsSectionTablet19,
  OsSectionMobile19,
  OsSectionDesktop20,
  OsSectionTablet20,
  OsSectionMobile20,
} from '@assets/images/main/os/section';
import { screenViewOs1, screenViewOs2, screenViewOs3, screenViewOs4, screenViewOs5 } from '@assets/images/main/screenView';

import { ReactComponent as SvgDashboardLine } from '@assets/images/icon/svg/dashboard-line.svg';
import { ReactComponent as SvgAppsLine } from '@assets/images/icon/svg/apps-line.svg';
import { ReactComponent as SvgMonitorLine } from '@assets/images/icon/svg/monitor-line.svg';
import { ReactComponent as SvgUsersLine } from '@assets/images/icon/svg/users-line.svg';
import { ReactComponent as SvgBellLine } from '@assets/images/icon/svg/bell-line.svg';

export default {
  bannerData: [
    {
      icon: IconOsServerOn,
      iconInv: IconOsServerOff,
      image: '',
      iconText: 'ORBRO服务器',
      sub: 'New',
      link: '/cn/os/server',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge RTLS',
      sub: 'New',
      link: '/cn/os/rtls',
    },
    {
      icon: IconOsEdgeOn,
      iconInv: IconOsEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/cn/os/ai',
    },
    {
      icon: IconOsSwitchOn,
      iconInv: IconOsSwitchOff,
      image: '',
      iconText: 'L2交换机',
      sub: 'New',
      link: '/cn/os/switch',
    },
  ],

  title: '多个空间和多种设备，<br/>一目了然的数字平台',
  desc: '通过预装于ORBRO服务器的 ORBRO OS，<br/>在一个界面上统一管理空间、设备和用户。<br/>随时随地查看实时信息，保障安全运营。',

  osLogo: {
    desktop: osLogoDesktop,
    tablet: osLogoTablet,
    mobile: osLogoMobile,
  },

  bannerImg: osBanner,

  screenView: {
    title: '用于实时现场监控的集成界面',
    data: [
      { icon: SvgDashboardLine, text: '仪表板主页', img: screenViewOs1 },
      { icon: SvgAppsLine, text: '提供小组件界面', img: screenViewOs2 },
      { icon: SvgMonitorLine, text: '支持多模态视图', img: screenViewOs3 },
      { icon: SvgUsersLine, text: '用户管理', img: screenViewOs4 },
      { icon: SvgBellLine, text: '通知与图层管理', img: screenViewOs5 },
    ],
  },
  section: {
    title: 'ORBRO OS 仅运行于<br/>ORBRO服务器和ORBRO Edge。',
    desc: '根据现场规模与环境，<br/>小型场所使用ORBRO Edge，大型场所使用ORBRO服务器，<br/>统一管理空间、设备和用户。',
    tag: [
      {
        icon: IconPcLine,
        title: '24小时稳定运行',
        desc: '坚固的硬件设计可无缝执行定位追踪、AI分析等任务。',
      },
      {
        icon: IconSecurity,
        title: '无需外部云，保障数据安全',
        desc: '数据不经外部云端，全部在内网或安全网中处理，保护敏感信息。',
      },
      {
        icon: IconLayers,
        title: '设备与传感器无限扩展',
        desc: '可持续添加无线定位标签、传感器、摄像头等多种设备，系统依然稳定运行。',
      },
    ],
    img: {
      desktop: OsSectionDesktop1,
      tablet: OsSectionTablet1,
      mobile: OsSectionMobile1,
    },
  },

  section1: {
    img: OsTextImg1,
    tag: '实时监控',
    title: '位置、视频、传感器，<br/>实时一览无余',
    desc: '整合查看IP/PTZ摄像头和温湿度、空气质量、火灾感应器。<br/>当检测到异常时，立即通过推送通知进行响应。',
    box: [
      {
        size: 1,
        title: '事件警报 & 实时定位监控',
        desc: '实时掌握建筑内部区域进出与事件，借助RTLS直观查看作业人员与访客位置。满足特定条件时立即推送警报，提升安保与运营响应能力。',
        img: {
          desktop: OsSectionDesktop2,
          tablet: OsSectionTablet2,
          mobile: OsSectionMobile2,
        },
      },
      {
        size: 2,
        title: '实时摄像头监控',
        desc: '查看注册摄像头的实时画面，一目了然掌握状态、连接情况和运行时间。异常发生时可立即排查，并结合 ORBRO AI 实现智能定位与目标识别。',
        img: {
          desktop: OsSectionDesktop3,
          tablet: OsSectionTablet3,
          mobile: OsSectionMobile3,
        },
      },
      {
        size: 2,
        title: '实时传感器监控',
        desc: '空气质量传感器实时采集并分析温度、湿度、PM2.5等环境数据。通过图表与仪表盘快速掌握环境变化，同时集中管理设备状态与安装位置。',
        img: {
          desktop: OsSectionDesktop4,
          tablet: OsSectionTablet4,
          mobile: OsSectionMobile4,
        },
      },
    ],
  },

  section2: {
    img: OsTextImg2,
    tag: '空间管理',
    title: '将物理空间数字化，<br/>打破虚实边界',
    desc: '通过注册建筑与楼层信息、定位设备，实现真实空间的数字孪生再现。<br/>上传3D图纸，打造更精细的虚拟环境。',
    box: [
      {
        size: 2,
        title: '空间管理',
        desc: '通过简单操作上传楼层图像并输入比例，生成与实际空间一致的数字地图。精准掌握每个区域位置，直观部署摄像头、传感器等设备，提升运营效率。',
        img: {
          desktop: OsSectionDesktop5,
          tablet: OsSectionTablet5,
          mobile: OsSectionMobile5,
        },
      },
      {
        size: 2,
        title: '区域管理',
        desc: '在图纸上自定义区域（Zone），并选择追踪对象（人员、设备、车辆等），有效管理该区域数据。实时掌握区域出入信息与事件状态，助力空间运营与安防管理。',
        img: {
          desktop: OsSectionDesktop6,
          tablet: OsSectionTablet6,
          mobile: OsSectionMobile6,
        },
      },
      {
        size: 1,
        title: '3D精细地图',
        desc: '上传3D文件获取更丰富的空间信息。清晰掌握楼层高度与设施布局等细节，提升空间利用率与安全性。',
        img: {
          desktop: OsSectionDesktop7,
          tablet: OsSectionTablet7,
          mobile: OsSectionMobile7,
        },
      },
    ],
  },
  section3: {
    img: OsTextImg3,
    tag: '应用功能',
    title: '记录、分析，<br/>自动响应的智能运营',
    desc: '记录并回放行动路径，利用热力图可视化移动趋势，<br/>通过SOP流程自动应对紧急情况。',
    box: [
      {
        size: 1,
        title: '热力图',
        desc: '根据保存的定位数据，展示某一时间段的人流与访问模式。选择特定日期与时间段，即可一目了然识别人群聚集区域，对空间布局、安全管理、营销策略均有帮助。',
        img: {
          desktop: OsSectionDesktop8,
          tablet: OsSectionTablet8,
          mobile: OsSectionMobile8,
        },
      },
      {
        size: 1,
        title: '记录',
        desc: '记录定位轨迹并回放特定时间段的移动路径。可用于安全监控、行动路径优化及设施运营分析等多个方面。',
        img: {
          desktop: OsSectionDesktop9,
          tablet: OsSectionTablet9,
          mobile: OsSectionMobile9,
        },
      },
      {
        size: 2,
        title: 'SOP流程设定',
        desc: '根据告警或事件设定标准操作流程（SOP），并自动执行各阶段操作。可灵活配置触发条件、响应步骤、负责人及短信通知，实现现场的快速一致响应。',
        img: {
          desktop: OsSectionDesktop10,
          tablet: OsSectionTablet10,
          mobile: OsSectionMobile10,
        },
      },
      {
        size: 2,
        title: 'SOP触发',
        desc: '当SOP被触发时，系统将依次显示发生区域、时间、条件等信息，并通过短信等方式立即与相关人员共享应对流程。',
        img: {
          desktop: OsSectionDesktop11,
          tablet: OsSectionTablet11,
          mobile: OsSectionMobile11,
        },
      },
    ],
  },

  section4: {
    img: OsTextImg4,
    tag: '管理员设置',
    title: '统一管理<br/>用户、群组、设备',
    desc: '通过直观界面，轻松添加、编辑、删除管理员/用户账号、通知群组、摄像头、传感器等所有设备。',
    box: [
      {
        size: 2,
        title: '用户管理',
        desc: '便捷设置和维护每位用户的账号类型、权限范围、联系方式等信息。',
        img: {
          desktop: OsSectionDesktop12,
          tablet: OsSectionTablet12,
          mobile: OsSectionMobile12,
        },
      },
      {
        size: 2,
        title: '群组管理',
        desc: '可将用户分组，如按组织或团队结构划分，便于系统化运营管理。',
        img: {
          desktop: OsSectionDesktop13,
          tablet: OsSectionTablet13,
          mobile: OsSectionMobile13,
        },
      },
      {
        size: 2,
        title: '条件通知管理',
        desc: '针对火灾、异常气体、人员入侵等事件设置告警条件及风险等级。根据风险等级自动推送定制消息，确保管理员和负责人能及时掌握并迅速应对。',
        img: {
          desktop: OsSectionDesktop14,
          tablet: OsSectionTablet14,
          mobile: OsSectionMobile14,
        },
      },
      {
        size: 2,
        title: '设备管理',
        desc: '统一注册与管理各种设备（摄像头、传感器、标签）。可实时查看设备状态、电量、网络连接，并进行必要设置，提升运营效率。',
        img: {
          desktop: OsSectionDesktop15,
          tablet: OsSectionTablet15,
          mobile: OsSectionMobile15,
        },
      },
    ],
  },

  section5: {
    img: OsTextImg4,
    tag: '',
    title: '无线、视频、GPS、门禁、IIoT<br/>全部一体化连接',
    desc: 'ORBRO OS全面支持从定位追踪、门禁控制，到工业物联网传感器的统一平台。<br/>欢迎查看完整产品线。',
    box: [
      {
        size: 1,
        title: '无线定位追踪',
        desc: '基于BLE、AoA、UWB等无线通信的定位功能',
        img: {
          desktop: OsSectionDesktop16,
          tablet: OsSectionTablet16,
          mobile: OsSectionMobile16,
        },
        link: 'https://orbro.io/cn/rtls',
      },
      {
        size: 2,
        title: '视频追踪',
        desc: '基于AI图像识别的目标追踪功能',
        img: {
          desktop: OsSectionDesktop17,
          tablet: OsSectionTablet17,
          mobile: OsSectionMobile17,
        },
        link: 'https://orbro.io/cn/camera',
      },
      {
        size: 2,
        title: '户外定位追踪',
        desc: '车辆与场地的GPS追踪',
        img: {
          desktop: OsSectionDesktop18,
          tablet: OsSectionTablet18,
          mobile: OsSectionMobile18,
        },
        link: 'https://orbro.io/cn/outdoor/gps',
      },
      {
        size: 2,
        title: '门禁系统',
        desc: '支持自动门、人脸识别等访问控制系统',
        img: {
          desktop: OsSectionDesktop19,
          tablet: OsSectionTablet19,
          mobile: OsSectionMobile19,
        },
        link: 'https://orbro.io/cn/access',
      },
      {
        size: 2,
        title: '工业物联网（IIoT）',
        desc: '连接空气质量/一氧化碳传感器、LoRA网关、机器人等',
        img: {
          desktop: OsSectionDesktop20,
          tablet: OsSectionTablet20,
          mobile: OsSectionMobile20,
        },
        link: 'https://orbro.io/cn/iot/LoRAGateway',
      },
    ],
  },

  downloadSection: {
    title: 'Web、移动、平板<br/>随时随地安全操作',
    desc: 'ORBRO OS 支持PC网页、iOS/Android应用程序和平板设备，<br/>均提供一致的操作界面。',
    ios: '下载 iOS',
    aos: '下载 Android',
    img: {
      desktop: osDownloadD,
      tablet: osDownloadT,
      mobile: osDownloadM,
    },
  },

  function: {
    title: '其他各种功能',
    box: [
      {
        icon: IconBlueScan,
        title: '实时数据分析和可视化',
        desc: 'OS可以分析和可视化收集的数据，使用户能够实时理解和利用收集到的信息。',
      },
      {
        icon: IconBlueShield,
        title: '安全和个人数据保护',
        desc: '提供强大的安全功能来保护数字孪生。限制对敏感信息的访问，并防止未经授权的数据修改，以最小化安全问题。',
      },
      {
        icon: IconBlueDevelop,
        title: '开发者友好',
        desc: '它将被开发为允许开发者轻松利用和扩展数字孪生功能。提供强大的API和开发工具，以开发新的应用程序和服务。',
      },
      {
        icon: IconBlueFigure,
        title: '人工智能整合',
        desc: '整合人工智能（AI）技术，以更智能地管理和优化数字孪生。使用AI算法分析数据并构建预测模型，以提高系统性能。',
      },
      {
        icon: IconBluePower,
        title: '环境监测和智能能源管理',
        desc: '整合环境监测传感器，以优化能源消耗和资源利用。实时监测环境状况，并根据需要自动调整系统，以最大程度地提高能源效率。',
      },
      {
        icon: IconBlueCycle,
        title: '自动化和智能控制',
        desc: '基于收集到的信息，通过数字孪生做出自动化决策。例如，在满足特定条件时自动控制设备或执行流程。',
      },
      {
        icon: IconBluePlus,
        title: '可定制的用户界面',
        desc: '提供用户根据需要定制界面的功能。用户可以自由配置用于监视和控制数字孪生的仪表板或应用程序。',
      },
      {
        icon: IconBlueCircle,
        title: '生态系统扩展性',
        desc: '建立允许开发人员和企业开发插件或插件以扩展系统的生态系统。这样，可以提供定制的解决方案，适用于各种行业和应用领域。',
      },
    ],
  },

  faqTitle: 'FAQ',

  beacon: {
    index: 4,
  },
  rtls: {
    index: 1,
  },
  camera: {
    index: 2,
  },
  access: {
    index: 3,
  },
  sensor: {
    index: 4,
  },
  integration: {
    index: 1,
  },
};
